import { render, staticRenderFns } from "./PromoRulesManager.vue?vue&type=template&id=b9a5e094&scoped=true"
import script from "./PromoRulesManager.vue?vue&type=script&lang=js"
export * from "./PromoRulesManager.vue?vue&type=script&lang=js"
import style0 from "./PromoRulesManager.vue?vue&type=style&index=0&id=b9a5e094&prod&scoped=true&lang=css"
import style1 from "./PromoRulesManager.vue?vue&type=style&index=1&id=b9a5e094&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a5e094",
  null
  
)

export default component.exports